<template>
    <div :class="(search_disp_sw)? 'main main--hasHeader main--hasFooter': ''">
        <div class="reserve04">
            <reserve-header :reserve_type="'facility'" :reserve_target="'reserve'" v-if="search_disp_sw"></reserve-header>
            <!-- {{ node_category_facility }} -->
            <div v-if="mgw_phase_production_001">
                <div class="fullContainer">
                    {{ word_chg('施設予約をする') }}
                </div>
            </div>
            <div v-else-if="reserve_step == 100">
                <div class="customContainer" v-if="search_disp_sw">
                    <div class="reserveRunSearch">
                        <div class="reserveRunSearch__row d-flex">
                            <div class="reserveRunSearch__name">
                                <label for="ReserveFacilityGroupId">日付</label>
                            </div>
                            <div class="reserveRunSearch__item">
                                <p>
                                    {{ sprm.date }}
                                </p>
                            </div>
                        </div>
                        <div class="reserveRunSearch__row d-flex" v-if="true">
                            <div class="reserveRunSearch__name">
                                <label for="ReserveFacilityGroupId">施設種別</label>
                            </div>
                            <div class="reserveRunSearch__item">
                                <p>
                                    {{ list_val_set(facility_group_id, node_category_group_facility) }}
                                </p>
                            </div>
                        </div>
                        <div class="reserveRunSearch__row d-flex" v-if="true">
                            <div class="reserveRunSearch__name">
                                <label for="ReserveFacilityGroupId">{{ get_facility_label }}</label>
                            </div>
                            <div class="reserveRunSearch__item">
                                <p>
                                    {{ list_val_set(sprm.category_id, node_category_facility) }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="fullContainer">
                    <hr class="reserve04__border">
                </div>
                <div class="fullContainer">
                    <div class="reserveTimeSchedule reserve04__schedule" v-if="true">
                        <div class="customContainer" v-if="Object.keys(facility_node_lists).length > 0">
                            <div v-for="list in facility_node_lists" :key="list">
                                <div v-if="typeof list.nodes === 'object' && Object.keys(list.nodes).length > 0">
                                    <div class="fullContainer">
                                        <div class="calendarPager">
                                            <div class="customContainer">
                                                <ul class="calendar__ul d-flex align-items-center justify-content-between">
                                                    <li class="calendarPager__button ">
                                                        <a class="calendarPager__link calendarPager__link--prev " @click="prev(10)">
                                                            <i class="bi bi-chevron-left"></i>
                                                        </a>
                                                    </li>
                                                    <li class="calendarPager__date">{{ list.label }}</li>
                                                    <li class="calendarPager__button "></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="reserve-stay-reserve-inner mb-4 "> 
                                        <!-- <h2 class="reserve05__h2" style="margin-bottom: 2rem;" >{{ list.label }}</h2> -->
                                        <div 
                                            v-if="Object.keys(list.ledger_type).length > 0">
                                            <div class="text-center py-4">
                                                <p>
                                                    {{ word_chg('オプション') }}
                                                </p>
                                            </div>
                                            <div class="reserveRunSearch__row d-flex" 
                                                v-for="ledger in list.ledger_type" :key="ledger">
                                                <div class="reserveRunSearch__name" v-if="ledger.is_user_view == 1">
                                                    <label for="ReserveFacilityGroupId">
                                                        {{ledger.label}}
                                                    </label>
                                                </div>
                                                <div class="" v-else>
                                                    <input :type="'hidden'" v-model="ledger.select_val" class="">
                                                </div>
                                                <div class="reserveRunSearch__item">
                                                    <p 
                                                        v-if="ledger.is_user_view == 1 && ['text', 'number', 'date'].includes(ledger.input_type)">
                                                        {{ word_chg(ledger.select_val) }}
                                                    </p>
                                                    <p 
                                                        v-else-if="ledger.is_user_view == 1 && ['texarea'].includes(ledger.input_type)">
                                                        {{ word_chg(ledger.select_val) }}
                                                    </p>
                                                    <p 
                                                        v-else-if="ledger.is_user_view == 1 && ['select'].includes(ledger.input_type) 
                                                        && typeof ledger.default_param === 'object'
                                                        ">
                                                        {{ list_val_set(ledger.select_val, ledger.default_param) }}
                                                    </p>
                                                    <p 
                                                        v-else-if="ledger.is_user_view == 1 && ['plus_minus'].includes(ledger.input_type) 
                                                        ">
                                                        {{ ledger.select_val }}
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="reserveRunSearch__row d-flex"
                                                v-if="count_option_price(list) > 0"
                                            >
                                                <div class="reserveRunSearch__name">
                                                    <label for="ReserveFacilityGroupId">
                                                        Option Total
                                                    </label>
                                                </div>
                                                <div class="reserveRunSearch__item">
                                                    <!-- {{ list_nodes_finish_options(list) }} -->
                                                    <p style="padding-top: 1.5rem;" class="text-end">
                                                        {{ count_min_label(list)}}{{ count_option_price_label(list) }}
                                                    </p>
                                                    <!-- {{ list.facility_node_finish }} -->
                                                </div>
                                            </div>
                                        </div>
                                        <div >
                                            <div class="text-center py-4">
                                                <p>
                                                    {{ word_chg('ご利用時間') }}
                                                </p>
                                            </div>
                                        </div>
                                        <div class="reserveRunSearch__row d-flex">
                                            <div class="reserveRunSearch__name">
                                                <label for="ReserveFacilityGroupId">{{ word_chg('開始時刻') }}</label>
                                            </div>
                                            <div class="reserveRunSearch__item">
                                                <p>
                                                    {{ list_val_set(list.facility_node_id, list_nodes_options(list.category_id)) }}
                                                </p>
                                            </div>
                                        </div>
                                        <div class="reserveRunSearch__row d-flex">
                                            <div class="reserveRunSearch__name">
                                                <label for="ReserveFacilityGroupId">{{ word_chg('終了時刻') }}</label>
                                            </div>
                                            <div class="reserveRunSearch__item">
                                                <p>
                                                    {{ list_val_set(list.facility_node_finish, list_nodes_finish_options(list)) }}
                                                </p>
                                            </div>
                                        </div>
                                        <!-- {{ list }} -->
                                        <div class="reserveRunSearch__row d-flex">
                                            <div class="reserveRunSearch__name">
                                                <label for="ReserveFacilityGroupId">
                                                    Price
                                                </label>
                                            </div>
                                            <div class="reserveRunSearch__item">
                                                <!-- {{ list_nodes_finish_options(list) }} -->
                                                <p style="padding-top: 1.5rem;" class="text-end">
                                                    {{ count_min_label(list)}}{{ count_price_label(list) }}
                                                </p>
                                                <!-- {{ list.facility_node_finish }} -->
                                            </div>
                                        </div>
                                        
                                        <div v-if="list.facility_node_finish != '' && list.facility_node_id != ''">
                                            <div class="reserveRunSearch__row d-flex">
                                                <div class="reserveRunSearch__name">
                                                    <label for="ReserveFacilityGroupId">
                                                        Total
                                                    </label>
                                                </div>
                                                <div class="reserveRunSearch__item">
                                                    <!-- {{ list_nodes_finish_options(list) }} -->
                                                    <p style="padding-top: 1.5rem;" class="text-end">
                                                        {{ total_price_label(list) }}
                                                    </p>
                                                    <!-- {{ list.facility_node_finish }} -->
                                                </div>
                                            </div>
                                        </div>
                                        <p class="reserve-stay-reserve-inner__reserve border-bottom border-dark pb-4">
                                            <button class="button02" @click="reserveNode(list)">{{ word_chg('予約する') }}</button>
                                            <!-- <button class="button02" @click="reserveNode(list)">予約する</button> -->
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="reserveTimeSchedule reserve04__schedule" v-else-if="facility_group_id">
                        <div class="customContainer" v-if="Object.keys(target_category).length > 0">
                            <div v-for="category in target_category" :key="category">
                                <div class="reserve-stay-reserve-inner">
                                    <p class="reserve-stay-reserve-inner__image"><img src="@/assets/img/main/reserve_stay_reserve_img_01.jpg" alt=""/></p>
                                    <p class="reserve-stay-reserve-inner__title">
                                        {{ category.label }}{{ category.sub_label }}<br>
                                        {{ category.front_status_label }}
                                    </p>
                                    <p class="reserve-stay-reserve-inner__title">
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="customContainer">

                        </div>
                    </div>
                    <p class="reserve04__button" v-else>
                        <!-- 施設を選択してください。 -->
                    </p>
                </div>

            </div>
            <div v-else-if="reserve_step == 10">
                <div class="customContainer" v-if="search_disp_sw">
                    <div class="reserveRunSearch">
                        <div class="reserveRunSearch__row d-flex">
                            <div class="reserveRunSearch__name">
                                <label for="ReserveFacilityGroupId">日付</label>
                            </div>
                            <div class="reserveRunSearch__item">
                                <p>
                                    <input class="reserveRunSearch__date" type="date" v-model="sprm.date" @change="searchNode()" />
                                </p>
                            </div>
                        </div>
                        <p class="reserve04__button" style="margin-bottom: 1.2rem;">
                            施設を選択してください。
                        </p>
                        <div class="reserveRunSearch__row d-flex" v-if="true">
                            <div class="reserveRunSearch__name">
                                <label for="ReserveFacilityGroupId">施設種別</label>
                            </div>
                            <div class="reserveRunSearch__item">
                                <p>
                                    <bs-select
                                        :options="node_category_group_facility"
                                        v-model="facility_group_id"
                                        :null-option="true"
                                        name="facility_group"
                                        id="ReserveFacilityGroupId"
                                        class="top__reserveOptionSelect"
                                        @parentFunc="changeGroup"
                                    ></bs-select>
                                </p>
                            </div>
                        </div>
                        <div class="reserveRunSearch__row d-flex" v-if="true">
                            <div class="reserveRunSearch__name">
                                <label for="ReserveFacilityGroupId">{{ get_facility_label }}</label>
                            </div>
                            <div class="reserveRunSearch__item">
                                <p>
                                    <bs-select
                                        :options="node_category_facility"
                                        v-model="sprm.category_id"
                                        name="facility_category"
                                        :null-option="'施設を選択して下さい'"
                                        id="ReserveFacilityGroupId"
                                        class="top__reserveOptionSelect"
                                        @parentFunc="changeGroup"
                                    ></bs-select>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="fullContainer">
                    <hr class="reserve04__border">
                </div>
                <div class="fullContainer">
                    <div class="reserveTimeSchedule reserve04__schedule" v-if="true">
                        <div class="customContainer" v-if="sprm.category_id != '' && sprm.category_id > 0 && Object.keys(facility_node_lists).length > 0">
                            <div v-for="list in facility_node_lists" :key="list">
                                <div v-if="typeof list.nodes === 'object' && Object.keys(list.nodes).length > 0">
                                    <div class="reserve-stay-reserve-inner mb-4 "> 
                                        <h2 class="reserve05__h2" ref="list_label" style="margin-bottom: 2rem;">{{ list.label }}</h2>
                                        <p class="reserve-stay-reserve-inner__title d-none">
                                            <span class="d-inline-block w-100 text-end">{{ list.unit_time }}min {{ list.price_label }}</span>
                                        </p>
                                        <!-- {{ list }} -->
                                        <p class="reserve-stay-reserve-inner__image" v-if="[25,26,28,29].includes(parseInt(list.category_id))">
                                            <img src="@/assets/img/main/facility_image_25.jpg" alt="" v-if="list.category_id=='25'"/>
                                            <img src="@/assets/img/main/facility_image_26.jpg" alt="" v-else-if="list.category_id=='26'"/>
                                            <img src="@/assets/img/main/facility_image_28.jpg" alt="" v-else-if="list.category_id=='28'"/>
                                            <img src="@/assets/img/main/facility_image_29.jpg" alt="" v-else-if="list.category_id=='29'"/>
                                        </p>
                                        <div v-if="[25,26,28,29].includes(parseInt(list.category_id))" style="">
                                            <p style="font-size: 1.3rem;" v-html="getGroupColumn('param_1')"></p>
                                        </div>
                                        <div 
                                            v-if="Object.keys(list.ledger_type).length > 0 && [25,26,30].includes(parseInt(list.category_id))">
                                            <div class="text-center py-4">
                                                <p>
                                                    {{ word_chg('オプションを選択して下さい') }}
                                                </p>
                                            </div>
                                            <!-- {{ get_minimum_unit_prm(list) }}: {{ list.ledger_type }} -->
                                            <div class="" 
                                                v-for="ledger in list.ledger_type" :key="ledger">
                                                <div 
                                                    :class="'reserveRunSearch__row ' + ledger_facility_meal_flg(ledger, list)">
                                                    <div class="reserveRunSearch__name" v-if="ledger.is_user_view == 1">
                                                        <label for="ReserveFacilityGroupId">
                                                            {{ledger.label}}
                                                        </label>
                                                    </div>
                                                    <div class="" v-else>
                                                        <input :type="'hidden'" v-model="ledger.select_val" class="">
                                                    </div>
                                                    <div class="reserveRunSearch__item">
                                                        <div 
                                                            v-if="ledger.is_user_view == 1 && ['text', 'number', 'date'].includes(ledger.input_type)">
                                                            <input :type="ledger.input_type" v-model="ledger.select_val" class="">
                                                            <div v-if="ledger.user_description" class="d-block">
                                                                <p style="font-size: 1.3rem;padding-bottom: 1rem;">{{ word_chg(ledger.user_description) }}</p>
                                                            </div>
                                                        </div>
                                                        <div 
                                                            v-else-if="ledger.is_user_view == 1 && ['texarea'].includes(ledger.input_type)">
                                                            <textarea v-model="ledger.select_val" class=""></textarea>
                                                            <div v-if="ledger.user_description" class="d-block">
                                                                <p style="font-size: 1.3rem;padding-bottom: 1rem;">{{ word_chg(ledger.user_description) }}</p>
                                                            </div>
                                                        </div>
                                                        <div 
                                                            v-else-if="ledger.is_user_view == 1 && ['select'].includes(ledger.input_type) 
                                                            && typeof ledger.default_param === 'object'
                                                            ">
                                                            <bs-select
                                                                :name="'facility_node_ledgers_' + ledger.id"
                                                                :options="ledger.default_param"
                                                                v-model="ledger.select_val"
                                                                :null-option="true"
                                                                @parentFunc="changeLedgerOptions(ledger)"
                                                                class="top__reserveOptionSelect"
                                                            ></bs-select>
                                                            <div v-if="ledger.user_description" class="d-block">
                                                                <p style="font-size: 1.3rem;padding-bottom: 1rem;">{{ word_chg(ledger.user_description) }}</p>
                                                            </div>
                                                        </div>
                                                        <div 
                                                            v-else-if="ledger.is_user_view == 1 && ['plus_minus'].includes(ledger.input_type)">
                                                            <div class="row">
                                                                <div class="col-2 text-center">
                                                                    <button @click="subtractLedgerPM(ledger)" class="btn btn-light btn-outline-secondary"><i class="bi bi-dash"></i></button>
                                                                </div>
                                                                <div class="col-2 text-center">
                                                                    {{ledger.select_val}} 
                                                                </div>
                                                                <div class="col-2 text-center">
                                                                    <button @click="addLedgerPM(ledger, 10)" class="btn btn-light btn-outline-secondary"><i class="bi bi-plus"></i></button>
                                                                </div>
                                                            </div>
                                                            <div v-if="ledger.user_description" class="d-block">
                                                                <p style="font-size: 1.3rem;padding-bottom: 1rem;">{{ word_chg(ledger.user_description) }}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="reserveRunSearch__row d-flex"
                                                v-if="count_option_price(list) > 0"
                                            >
                                                <div class="reserveRunSearch__name">
                                                    <label for="ReserveFacilityGroupId">
                                                        Option Total
                                                    </label>
                                                </div>
                                                <div class="reserveRunSearch__item">
                                                    <!-- {{ list_nodes_finish_options(list) }} -->
                                                    <p style="padding-top: 1.5rem;" class="text-end">
                                                        {{ count_min_label(list)}}{{ count_option_price_label(list) }}
                                                    </p>
                                                    <!-- {{ list.facility_node_finish }} -->
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="nonledger_facility_meal_flg(list)">
                                            <div class="text-center py-4">
                                                <p>
                                                    {{ word_chg('ご利用時間を選択して下さい') }}
                                                </p>
                                            </div>
                                        </div>
                                        <div v-if="nonledger_facility_meal_flg(list)" class="reserveRunSearch__row d-flex">
                                            <div class="reserveRunSearch__name">
                                                <label for="ReserveFacilityGroupId">{{ word_chg('開始時刻') }}</label>
                                            </div>
                                            <div class="reserveRunSearch__item">
                                                <p>
                                                    <bs-select
                                                        :options="list_nodes_options(list.category_id)"
                                                        v-model="list.facility_node_id"
                                                        :name="'facility_node_id_' + list.category_id"
                                                        :null-option="true"
                                                        class="top__reserveOptionSelect"
                                                        @parentFunc="changeNodeOptions()"
                                                    ></bs-select>
                                                </p>
                                                <!-- {{ list.facility_node_id }} -->
                                            </div>
                                        </div>
                                        <div v-if="nonledger_facility_meal_flg(list)" class="reserveRunSearch__row d-flex">
                                            <div class="reserveRunSearch__name">
                                                <label for="ReserveFacilityGroupId">{{ word_chg('終了時刻') }}</label>
                                            </div>
                                            <div class="reserveRunSearch__item">
                                                <p>
                                                    <bs-select
                                                        :name="'facility_node_finish_' + list.category_id"
                                                        :options="list_nodes_finish_options(list)"
                                                        v-model="list.facility_node_finish"
                                                        :null-option="true"
                                                        @parentFunc="changeFinishOptions(list)"
                                                        class="top__reserveOptionSelect"
                                                    ></bs-select>
                                                </p>
                                                <!-- {{ list.facility_node_finish }} -->
                                            </div>
                                        </div>
                                        <div v-if="nonledger_facility_meal_flg(list)" class="reserveRunSearch__row d-flex">
                                            <div class="reserveRunSearch__name">
                                                <label for="ReserveFacilityGroupId">
                                                    Price
                                                </label>
                                            </div>
                                            <div class="reserveRunSearch__item">
                                                <p style="padding-top: 1.5rem;" class="text-end">
                                                    {{ count_price_label(list) }}
                                                </p>
                                            </div>
                                        </div>
                                        
                                        <div 
                                            v-if="Object.keys(list.ledger_type).length > 0 && [25,26,30].includes(parseInt(list.category_id)) == false">
                                            <div class="text-center py-4">
                                                <p>
                                                    {{ word_chg('オプションを選択して下さい') }}
                                                </p>
                                            </div>
                                            <div class="reserveRunSearch__row d-flex" 
                                                v-for="ledger in list.ledger_type" :key="ledger">
                                                <div class="reserveRunSearch__name" v-if="ledger.is_user_view == 1">
                                                    <label for="ReserveFacilityGroupId">
                                                        {{ledger.label}}
                                                    </label>
                                                </div>
                                                <div class="" v-else>
                                                    <input :type="'hidden'" v-model="ledger.select_val" class="">
                                                </div>
                                                <div class="reserveRunSearch__item">
                                                    <div 
                                                        v-if="ledger.is_user_view == 1 && ['text', 'number', 'date'].includes(ledger.input_type)">
                                                        <input :type="ledger.input_type" v-model="ledger.select_val" class="">
                                                        <div v-if="ledger.user_description" class="d-block">
                                                            <p style="font-size: 1.3rem;padding-bottom: 1rem;">{{ word_chg(ledger.user_description) }}</p>
                                                        </div>
                                                    </div>
                                                    <div 
                                                        v-else-if="ledger.is_user_view == 1 && ['texarea'].includes(ledger.input_type)">
                                                        <textarea v-model="ledger.select_val" class=""></textarea>
                                                        <div v-if="ledger.user_description" class="d-block">
                                                            <p style="font-size: 1.3rem;padding-bottom: 1rem;">{{ word_chg(ledger.user_description) }}</p>
                                                        </div>
                                                    </div>
                                                    <div 
                                                        v-else-if="ledger.is_user_view == 1 
                                                        && ['select'].includes(ledger.input_type) 
                                                        && typeof ledger.default_param === 'object'
                                                        ">
                                                        <bs-select
                                                            :name="'facility_node_ledgers_' + ledger.id"
                                                            :options="select_item_option(ledger, list)"
                                                            v-model="ledger.select_val"
                                                            :null-option="select_item_option_null(ledger, list)"
                                                            @parentFunc="changeLedgerOptions(ledger)"
                                                            class="top__reserveOptionSelect"
                                                        ></bs-select>
                                                        <div v-if="ledger.user_description" class="d-block">
                                                            <p style="font-size: 1.3rem;padding-bottom: 1rem;">{{ word_chg(ledger.user_description) }}</p>
                                                        </div>
                                                    </div>
                                                    <div 
                                                        v-else-if="ledger.is_user_view == 1 && ['plus_minus'].includes(ledger.input_type)">
                                                        <div class="row">
                                                            <div class="col text-center">
                                                                <button @click="subtractLedgerPM(ledger)" class="btn btn-light btn-outline-secondary"><i class="bi bi-dash"></i></button>
                                                            </div>
                                                            <div class="col text-center">
                                                                {{ledger.select_val}} 
                                                            </div>
                                                            <div class="col text-center">
                                                                <button @click="addLedgerPM(ledger, 6)" class="btn btn-light btn-outline-secondary"><i class="bi bi-plus"></i></button>
                                                            </div>
                                                        </div>
                                                        <div v-if="ledger.user_description" class="d-block">
                                                            <p style="font-size: 1.3rem;padding-bottom: 1rem;">{{ word_chg(ledger.user_description) }}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="reserveRunSearch__row d-flex"
                                                v-if="count_option_price(list) > 0"
                                            >
                                                <div class="reserveRunSearch__name">
                                                    <label for="ReserveFacilityGroupId">
                                                        Option Total
                                                    </label>
                                                </div>
                                                <div class="reserveRunSearch__item">
                                                    <!-- {{ list_nodes_finish_options(list) }} -->
                                                    <p style="padding-top: 1.5rem;" class="text-end">
                                                        {{ count_min_label(list)}}{{ count_option_price_label(list) }}
                                                    </p>
                                                    <!-- {{ list.facility_node_finish }} -->
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="list.facility_node_finish != '' && list.facility_node_id != ''">
                                            <div class="reserveRunSearch__row d-flex">
                                                <div class="reserveRunSearch__name">
                                                    <label for="ReserveFacilityGroupId">
                                                        Total
                                                    </label>
                                                </div>
                                                <div class="reserveRunSearch__item">
                                                    <!-- {{ list_nodes_finish_options(list) }} -->
                                                    <p style="padding-top: 1.5rem;" class="text-end">
                                                        {{ total_price_label(list) }}
                                                    </p>
                                                    <!-- {{ list.facility_node_finish }} -->
                                                </div>
                                            </div>
                                        </div>
                                        <p v-if="nonledger_facility_meal_flg(list)" class="reserve-stay-reserve-inner__reserve border-bottom border-dark pb-4">
                                            <button class="button02" @click="confirm(list)">{{ word_chg('予約内容を確認する') }}</button>
                                            <!-- <button class="button02" @click="reserveNode(list)">予約する</button> -->
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="reserveTimeSchedule reserve04__schedule" v-else-if="facility_group_id">
                        <div class="customContainer" v-if="Object.keys(target_category).length > 0">
                            <div v-for="category in target_category" :key="category">
                                <div class="reserve-stay-reserve-inner">
                                    <p class="reserve-stay-reserve-inner__image"><img src="@/assets/img/main/reserve_stay_reserve_img_01.jpg" alt=""/></p>
                                    <p class="reserve-stay-reserve-inner__title">
                                        {{ category.label }}{{ category.sub_label }}<br>
                                        {{ category.front_status_label }}
                                    </p>
                                    <p class="reserve-stay-reserve-inner__title">
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="customContainer">

                        </div>
                    </div>
                    <p class="reserve04__button" v-else>
                        <!-- 施設を選択してください。 -->
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
    .reserveRunSearch__item p {
        padding-top: 1.5003750938rem;
    }
</style>
<script>
import reserveHeader from '../../organisms/BsReserveHeader.vue';
import BsSelect from '../../atoms/BsSelect.vue'
import { mapState } from 'vuex'
import moment from 'moment'
import config from '../../../const'
// import axios from 'axios'
// import Common from '../../../common/common'

export default {
    name: 'FacilityView',
    data: function () {
        return {
            sprm: {
                date: moment().format("YYYY-MM-DD"),
                day: moment().format("D"),
                reserve_num: 1,
                reserve_stay: 2,
                category_id: 0,
                consecutive_cnt: 10,
                is_guest: false
            },
            sprmFrmDetailSw: false,
            selected_node_ids: [],

            reserve_node: [],

            add_friend_list: [],
            facility_group_id_st: 0,

            reserve_step: 10,

            // facility_node_id_st: [],
            // facility_node_finish_st: [],
        }
    },
    props: {
        facility_group_id_obj: {
            type: Number,
            default: 0
        },
        // param_category_id: {
        //     type: Number,
        //     // default: 1
        // },
        search_disp_sw: {
            type: Boolean,
            default: true
        },
    },
    components: {
        reserveHeader,
        BsSelect,
    },
    methods: {
        confirm(list){
            let check = true;
            const msg = [];
            // 内容をチェック
            if(!list){
                alert('error');
                return false;
            }
            else if(
                (
                    !list.facility_node_finish
                    || !list.facility_node_id
                )
            ){
                alert('error');
                return false;
            }


            if(!check){
                // let message = '';
                if(msg.length > 0){
                    // msg.forEach(m => {
                    //     message += this.word_chg(m) + ',';
                    // })
                    alert(msg.join('\n'));
                }
                // alert(message);
            }else{
                window.scrollTo(0, 0);
                this.reserve_step = 100;
            }
            this.reserve_step = 100;
        },
        prev(step){
            this.reserve_step = step;
        },
        reserveNode(list){
            if(!list){
                alert('error');
                return false;
            }
            else if(
                (
                    !list.facility_node_finish
                    || !list.facility_node_id
                )
            ){
                alert('error');
                return false;
            }


            const params = {};
            const user = this.getMyData;
            console.log('reserveNode reserve_node', list, user);

            params['m_id'] = this.$store.state.auth.userId;
            params['node_type'] = 'facility';
            if(list.consecutive_cnt) params['consecutive_cnt'] = list.consecutive_cnt;
            console.log('reserveNode first params', params);
            // 連続したnodeをidsから指定する
            // facility_node_idをnodesから取得
            // facility_node_finishをnodes[facility_node_id][consecutive_ids]をforEachし、finishまでカウントする。
            // finishまでのnodeをnodesから取得してreservation変数に入れていく。
            
            const reserve_nodes = [];

            const start_node = (list.facility_node_id > 0 && list.nodes)? list.nodes.find(node => {
                return (node.id == list.facility_node_id)
            }): false;
            console.log('reserveNode start_node', start_node);
            if(start_node) reserve_nodes.push(start_node);

            const consecutive_ids = (start_node && typeof start_node.consecutive_ids === 'object')?
                start_node.consecutive_ids: false;
            console.log('reserveNode consecutive_ids', consecutive_ids);
            
            // const consecutive_nodes = [];
            if(consecutive_ids){
                let breakSw = false;
                consecutive_ids.forEach(node_id => {
                    if(!breakSw){
                        reserve_nodes.push(list.nodes.find(node => {
                            return (node.id == node_id)
                        }));
                    }
                    if(parseInt(node_id) == parseInt(list.facility_node_finish)){
                        breakSw = true;
                    }
                })
            }
            console.log('reserveNode reserve_nodes ', reserve_nodes);
            
            if(typeof reserve_nodes === 'object' && reserve_nodes.length > 0){

                console.log('reserveNode reserve_nodes', reserve_nodes);
            }

            if(typeof reserve_nodes === 'object' && reserve_nodes.length > 0){
                const reservation = [];

                const ledger_data = [];
                if(typeof list.ledger_type === 'object' && list.ledger_type.length > 0){
                    // 基本
                    list.ledger_type.forEach(ledger => {
                        ledger_data.push(
                            {
                                'reservation_node_id': 0,
                                'node_id': 0,
                                'type_id': ledger.id,
                                'row': 0,   // 1行しかない予定
                                'value': ledger.select_val,
                                'price': ledger.select_val_price,
                                'sel_ledger': ledger
                            }
                        )
                    });
                }

                Object.values(reserve_nodes).forEach(node => {
                    let setPrice = 0;

                    setPrice = (node.price)? parseInt(node.price): 0;

                    const ledgers = []
                    if(ledger_data.length > 0){
                        ledger_data.forEach(ledger => {
                            const ledger_tmp = {...ledger};
                            ledger_tmp['node_id'] = node.id;
                            ledgers.push({...ledger_tmp});
                            if(ledger.price && parseInt(ledger.price) > 0){
                                setPrice += parseInt(ledger.price);
                            }
                            // list.ledger_type.find(type => {
                            //     if(
                            //         type.id == ledger.type_id 
                            //         && type.input_type == 'select'
                            //         && typeof type.default_param === 'object' 
                            //         && type.default_param.find()
                            //         ){

                            //     }
                            // })
                        })
                    }
                    const tmp = {
                                reservation_id: 0,
                                consecutive_ids: [],
                                node_id: node.id,
                                use_m_id: user.id,
                                // kbn_id: (user.kbn && user.kbn.id)? user.kbn.id: 0,
                                checkin_id: 0,
                                use_guest_id: 0,
                                is_use: 0,
                                is_guest: 0,
                                is_cancel: 0,
                                price: setPrice,
                                ledger: ledgers,
                                note: {}
                            };
                    console.log('reserveNode tmp', tmp);
                    reservation.push({...tmp});
                });
                params['reserve'] = reservation;
            }
            console.log('reserveNode params', params);
            return this.$store.dispatch('updateBasic', {data: params, target: 'reservation' })
                .then(() => {
                    // // this.back()
                    alert('予約しました');
                    // this.alertMessage = this.btnLabel + 'しました';
                    // this.alertClass = 'alert-success';
                })
                .catch(
                    () => {
                    err => Promise.reject(err);
                    alert('予約できませんでした');
                    // this.alertMessage = this.btnLabel + 'できませんでした';
                    // this.alertClass = 'alert-danger';
                    }
                )
                .finally(() => {
                    // this.$refs.closeRsvModal.click();
                    this.$forceUpdate();
                    // this.$refs.closeNodeModalParent.click();
                    this.$router.push({ path: '/' })
                });
        },
        changeNodeOptions(){
            // console.log('changeNodeOptions', list);
            this.$forceUpdate();
            // console.log('changeNodeOptions2', list);

        },
        changeFinishOptions(list){
            console.log('changeFinishOptions', list);
            // const node_id = list.facility_node_id;
            // const finish_id = list.facility_node_finish;


            const start_node = (list.facility_node_id > 0 && list.nodes)? list.nodes.find(node => {
                return (node.id == list.facility_node_id)
            }): false;
            console.log('changeFinishOptions start_node', start_node);

            const consecutive_ids = (start_node && typeof start_node.consecutive_ids === 'object')?
                start_node.consecutive_ids: false;
            console.log('changeFinishOptions consecutive_ids', consecutive_ids);
            
            // const consecutive_nodes = [];
            let count = 1;
            if(consecutive_ids){
                let breakSw = false;
                consecutive_ids.forEach(node_id => {
                    if(!breakSw){
                        count++;
                    }
                    if(parseInt(node_id) == parseInt(list.facility_node_finish)){
                        breakSw = true;
                    }
                })
            }
            list.consecutive_cnt = count;
            console.log('changeFinishOptions count ', list);

            this.$forceUpdate();
        },
        changeLedgerOptions(ledger){
            const select_param = ledger.default_param.find((param) => {
                return param.id == ledger.select_val
            });
            ledger.select_val_price = (select_param)? select_param.price: 0;
            // console.log('changeNodeOptions', list);
            this.$forceUpdate();
            // console.log('changeNodeOptions2', list);
        },
        // 
        addLedgerPM(ledger, limit){
            console.log('addLedgerPM 1', ledger, limit);
            let upd_val = 0;
            if(
                parseInt(ledger.select_val) < parseInt(limit)
            ){
                upd_val = ledger.select_val + 1;
            }
            else if(
                upd_val == 0
            ){
                upd_val = 1;
            }
            ledger.select_val = upd_val;
            console.log('addLedgerPM 2', ledger.select_val, limit);
            this.$forceUpdate();
        },
        subtractLedgerPM(ledger){
            console.log('subtractLedgerPM', ledger);
            if(
                parseInt(ledger.select_val) > 0
            ){
                const upd_val = ledger.select_val - 1;
                ledger.select_val = upd_val;
            }
            // console.log('changeNodeOptions', list);
            this.$forceUpdate();
            // console.log('changeNodeOptions2', list);
        },
        changeGroup(){
            this.loadFacilityCategory();
            if(this.sprm.category_id != '' && this.$refs && typeof this.$refs.list_label === 'object'){
            console.log('changeGroup this.sprm.category_id', this.sprm.category_id, this.$refs.list_label);
                const rect = this.$refs.list_label[0].getBoundingClientRect();
                window.scrollTo(0, rect.top);
            }
        },
        // 検索
        searchNode(){
            this.loadFacilityNode();
        },
        // load
        loadUser(){
            const params = {};
            params['id'] = this.$store.state.auth.userId;
            console.log('params', params);
            return this.$store.dispatch('fetchBasicLists', {data: params, target: 'user', targetF: 'get'})
            .catch((err) => {
            console.log(err);
            Promise.reject(err)
            })
            .then(() => {})
            .finally(() => {});
        },
        loadFacilityCategory() {
            const params = {};
            params['stat'] = 1;
            return this.$store.dispatch('fetchBasicLists', {data: params, target: 'facility_node_category'})
                        .catch(err => Promise.reject(err))
                        .then(() => {})
                        .finally(() => {});
        },
        loadCategoryGroup() {
            const params = {};
            params['stat'] = 1;
            return this.$store.dispatch('fetchBasicLists', {data: params, target: 'node_category_group'})
                        .catch(err => Promise.reject(err))
                        .then(() => {})
                        .finally(() => {});
        },
        loadLedgerType(){
            const params = {};
            params['stat'] = 1;
            params['type'] = 'facility';
            return this.$store.dispatch('fetchBasicLists', {data: params, target: 'ledger_type'})
                        .catch(err => Promise.reject(err))
                        .then(() => {
                        })
                        .finally(() => {
                        })

        },
        loadFacilityNode () {
            console.log('loadFacilityNode');
            const params = {};
            params['stat'] = [1];
            // params['category_id'] = this.sel_paddock;
            params['range_start_date'] = this.sprm.date;
            params['range_end_date'] = this.sprm.date;
            params['consecutive_cnt'] = 1;
            // category
            if(this.sprm.category_id) params['category_id'] = this.sprm.category_id;
            // guest走行
            if(this.sprm.is_guest){
                params['guest_accept_flg'] = 1;
            }

            console.log('loadFacilityNode params', params);
            return this.$store.dispatch('fetchBasicLists', {data: params, target: 'facility_node'})
                        .catch(err => Promise.reject(err))
                        .then(() => {
                            console.log('loard complete facility_node');
                            console.log('this', this.$store.state.apidata.facility_node);
                        })
                        .finally(() => {
                            console.log('finally', this.$store.state.apidata.facility_node);
                        })
        },


    },
    computed: {
        ...mapState({
            facility_node_category: state => state.apidata.facility_node_category,
            kbn_list: state => state.apidata.member_kbn,
            facility_node: state => state.apidata.facility_node,
            ledger_type: state => state.apidata.ledger_type,
            user: state => state.apidata.user,
            node_category_group: state => state.apidata.node_category_group,
        }),
        ledger_facility_meal_flg_list_val_chk: function(){
            return function(list){
                const list_val_chk = 
                (
                    typeof list === 'object' 
                    && typeof list.ledger_type === 'object' 
                    && typeof list.ledger_type.find(lt => lt.relation_column == 'facility_meal') === 'object' 
                    && (
                        list.ledger_type.find(lt => lt.relation_column == 'facility_meal').select_val == '' 
                        || parseInt(list.ledger_type.find(lt => lt.relation_column == 'facility_meal').select_val) == 0 
                    )
                )? true
                : false;

                return list_val_chk;
            }
        },
        nonledger_facility_meal_flg: function(){
            const ledger_facility_meal_flg_list_val_chk = this.ledger_facility_meal_flg_list_val_chk;
            const facility_group_id = this.facility_group_id;
            return function(list){
                const list_val_chk = ledger_facility_meal_flg_list_val_chk(list);

                if(
                    parseInt(facility_group_id) == 9 
                    && list_val_chk == true
                ){
                    return false;
                }
                return true;
            }
        },
        ledger_facility_meal_flg: function(){
            const ledger_facility_meal_flg_list_val_chk = this.ledger_facility_meal_flg_list_val_chk;
            const facility_group_id = this.facility_group_id;
            return function(ledger, list){
                const list_val_chk = ledger_facility_meal_flg_list_val_chk(list);

                if(
                    parseInt(facility_group_id) == 9 
                    && ledger.relation_column != 'facility_meal' 
                    && list_val_chk == true
                ){
                    return 'd-none';
                }
                return 'd-flex';
            }
        },
        select_item_option: function(){
            const category_id = this.sprm.category_id;
            return function(ledger, list){
                if(
                    (category_id == '28' || category_id == '29')
                    && typeof ledger === 'object' 
                    && typeof ledger.relation_column === 'string' 
                ){
                    const start_node = (parseInt(list.facility_node_id) > 0)? list.nodes.find(node => {
                            return (node.id == list.facility_node_id)
                    }): false;
                    const finish_node = (parseInt(list.facility_node_finish) > 0)? list.nodes.find(node => {
                            return (node.id == list.facility_node_finish)
                    }): false;
                    if(
                        ledger.relation_column.indexOf('alcohol_') === 0 
                    ){
                        const set_time = parseInt(ledger.relation_column.replace('alcohol_', '') + '00');

                        if(
                            (
                                typeof start_node === 'object' 
                                && typeof start_node.items === 'object'
                                && typeof start_node.items[0] === 'object' 
                                && typeof start_node.items[0].start_date_time === 'string' 
                                && parseInt(start_node.items[0].start_date_time.replace(':', '')) >= set_time
                            ) || (
                                typeof finish_node === 'object' 
                                && typeof finish_node.items === 'object' 
                                && typeof finish_node.items[0] === 'object' 
                                && typeof finish_node.items[0].end_date_time === 'string'
                                && parseInt(finish_node.items[0].end_date_time.replace(':', '')) > set_time
                            )
                        ){
                            return ledger.default_param;
                        }
                        return [];
                        // const node_options = list_nodes_options(category_id);
                    }

                }
                return ledger.default_param;
            }
        },
        select_item_option_null: function(){
            const category_id = this.sprm.category_id;
            return function(ledger, list){
                if(
                    (category_id == '28' || category_id == '29')
                    && typeof ledger === 'object' 
                    && typeof ledger.relation_column === 'string' 
                ){
                    const start_node = (parseInt(list.facility_node_id) > 0)? list.nodes.find(node => {
                            return (node.id == list.facility_node_id)
                    }): false;
                    const finish_node = (parseInt(list.facility_node_finish) > 0)? list.nodes.find(node => {
                            return (node.id == list.facility_node_finish)
                    }): false;
                    if(
                        ledger.relation_column.indexOf('alcohol_') === 0 
                    ){
                        const set_time = parseInt(ledger.relation_column.replace('alcohol_', '') + '00');

                        if(
                            (
                                typeof start_node === 'object' 
                                && typeof start_node.items === 'object'
                                && typeof start_node.items[0] === 'object' 
                                && typeof start_node.items[0].start_date_time === 'string' 
                                && parseInt(start_node.items[0].start_date_time.replace(':', '')) >= set_time
                            ) || (
                                typeof finish_node === 'object' 
                                && typeof finish_node.items === 'object' 
                                && typeof finish_node.items[0] === 'object' 
                                && typeof finish_node.items[0].end_date_time === 'string'
                                && parseInt(finish_node.items[0].end_date_time.replace(':', '')) > set_time
                            )
                        ){
                            return true;
                        }
                        return 'ノンアルコールフリー';
                        // const node_options = list_nodes_options(category_id);
                    }

                }
                return true;
            }
        },
        get_facility_label: function(){
            const facility_group_id = this.facility_group_id;
            if(
                parseInt(facility_group_id) == 10
            ){
                return this.word_chg('コース');
            }
            else if(parseInt(facility_group_id) == 9){
                return '';
            }
            else{
                return this.word_chg('施設');
            }
        },
        get_ledger_type_data: function(){
            const lt = this.ledger_type;
            return (target) => {
                const type = Object.values(lt).filter((value) => {
                if(value.id == target) return value;
            });
                return type[0];
            }
        },
        list_val_set: function(){
            return function(val, options){
                console.log('list_val_set options', options);
                if(typeof options === 'object'){
                    const option = options.find((data) => {
                        return data.key == val;
                    })
                    return (typeof option === 'object')? this.word_chg(option.label): '';
                }
                return val;
            }
        },
        axiosHeader: function(){
            return {[config.BASE_API_HEADER_KEY]: this.$store.state.auth.token};
        },
        getGroupColumn: function(){
            const groups = this.node_category_group_facility;
            const group_id = this.facility_group_id;
            // console.log('getGroupColumn', group_id, groups);
            return function(column){
                const res = groups.find(group => {return group.id == group_id});
            // console.log('getGroupColumn column', column);
            // console.log('getGroupColumn res', res);
                if(
                    typeof res === 'object' && typeof res[column] !== 'undefined'
                ){
            // console.log('getGroupColumn res.column', res[column]);
                    return res[column];
                }
                return '';
            }
        },
        // login user
        getMyData: function(){
            const mydata = this.user.find((data) => {
            return data.id == this.$store.state.auth.userId;
            })
            return mydata;
        },
        count_min_label: function(){
            const count_min_pf = this.count_min;
            return function (list){
                const p = count_min_pf(list);
                if(!p){
                    return '';
                }
                else{
                    let pp = p;
                    pp += 'min';

                    if(list.unit_time && parseInt(list.unit_time) < parseInt(p)){
                        pp += '(' + list.unit_time + 'min × ' + Math.floor(parseInt(p) / parseInt(list.unit_time)) + ')';
                    }

                    pp += ' : ';
                    return pp;
                }
            }
        },
        count_min: function(){
            // const facility_nodes = this.facility_node;
            return function (list){
                // const tmps = [];
                const node_id = list.facility_node_id;
                const finish_id = list.facility_node_finish;

                if(typeof list === 'object' && list.nodes && typeof list.nodes === 'object'){
                    const target_node = list.nodes.find(node => {
                        return (node.id == node_id)
                    });
                    const unit_time = (list.unit_time)? parseInt(list.unit_time): 30;
                    if(
                        typeof target_node === 'object' && target_node.consecutive_ids && 
                        typeof target_node.consecutive_ids === 'object' && target_node.consecutive_ids.length > 0
                        ){
                            const index = target_node.consecutive_ids.indexOf(finish_id);
                            return (index >= 0)? (index + 2) * unit_time: false;
                    }
                }
            }
        },
        total_price_label: function(){
            const total_price_pf = this.total_price;
            return function (list){
                const p = total_price_pf(list);
                if(!p || p == false){
                    return '';
                }
                else{
                    return '¥' + this.number_format(p);
                }
            }
        },
        total_price: function(){
            const count_price_pf = this.count_price;
            const count_option_price_pf = this.count_option_price;
            return function (list){
                const count_price = count_price_pf(list);
                let total_price = parseInt(count_price);
                let ledger_price = count_option_price_pf(list);
                // let ledger_price = 0;
                // if(
                //     list.ledger_type && typeof list.ledger_type === 'object' 
                // ){
                //     list.ledger_type.forEach(ledger => {
                //         ledger_price += (ledger.select_val_price)? parseInt(ledger.select_val_price): 0;
                //     });
                //     console.log('total_price', ledger_price, count_price);
                // }
                // if(
                //     list.consecutive_cnt > 1
                // ){
                //     total_price += (ledger_price * parseInt(list.consecutive_cnt));
                // }
                total_price += (ledger_price)? ledger_price: 0;
                return total_price;
            }
        },
        count_option_price_label: function(){
            const count_option_price_pf = this.count_option_price;
            return function (list){
                const p = count_option_price_pf(list);
                console.log('count_option_price_label', p, list);
                if(!p || p == false){
                    return '';
                }
                else{
                    return '¥' + p;
                }
            }
        },
        count_option_price: function(){
            const facility_nodes = this.facility_node;
            return function(list){
                let ledger_price_non = 0;
                // 別オプション
                let ledger_price_rc = {};
                if(
                    list.ledger_type && typeof list.ledger_type === 'object' 
                ){
                    list.ledger_type.forEach(ledger => {
                        // ledger_price_non += (ledger.select_val_price)? parseInt(ledger.select_val_price): 0;
                        if(ledger.relation_column != ''){
                            if(!ledger_price_rc[ledger.relation_column]) ledger_price_rc[ledger.relation_column] = 0;
                            ledger_price_rc[ledger.relation_column] += parseInt(ledger.select_val_price);
                        }
                        else{
                            ledger_price_non += (ledger.select_val_price)? parseInt(ledger.select_val_price): 0;
                        }
                    });
                }
                const node_id = list.facility_node_id;
                const finish_id = list.facility_node_finish;

                if(typeof list === 'object' && list.nodes && typeof list.nodes === 'object'){
                    const target_node_ = list.nodes.find(node => {
                        return (node.id == node_id)
                    });
                    const target_node = {...target_node_};
                    // const unit_time = (list.unit_time)? parseInt(list.unit_time): 30;
                    if(
                        typeof target_node === 'object' && target_node.consecutive_ids && 
                        typeof target_node.consecutive_ids === 'object' && target_node.consecutive_ids.length > 0
                        ){
                            let cnt = 0;
                            const cons_ids = [...target_node.consecutive_ids];
                            const tmps_ids = [node_id];
                            target_node.consecutive_ids = tmps_ids.concat(cons_ids);
                            // let total = (target_node.price)? parseInt(target_node.price): 0;
                            // let total = (parseInt(ledger_price_non) > 0)? parseInt(ledger_price_non): 0;
                            let total = 0;
                            const index = target_node.consecutive_ids.indexOf(finish_id);
                            target_node.consecutive_ids.forEach(consecutive_id => {
                                if(cnt <= index){
                                    const consecutive_node = facility_nodes.find((facility_node) => {
                                        return parseInt(facility_node.id) == parseInt(consecutive_id)
                                    });
                                    console.log('count_option_price cnt, index', cnt, index, consecutive_node.items[0].start_date_time);
                                    Object.keys(ledger_price_rc).forEach(rc_key => {
                                        // アルコール何時以降チェック
                                        const set_time = parseInt(rc_key.replace('alcohol_', '') + '00');      
                        // console.log('count_option_price consecutive_cnt rc_key, set_time', rc_key, set_time, parseInt(ledger_price_rc[rc_key]), consecutive_node);   
                                        if(
                                            parseInt(ledger_price_rc[rc_key]) > 0 
                                            && typeof consecutive_node === 'object' 
                                            && typeof consecutive_node.items === 'object' 
                                            && Object.keys(consecutive_node.items).length > 0 
                                            && typeof consecutive_node.items[0] === 'object' 
                                            && typeof consecutive_node.items[0].start_date_time === 'string' 
                                            && parseInt(consecutive_node.items[0].start_date_time.replace(':', '')) >= set_time
                                        ){
                                            total += parseInt(ledger_price_rc[rc_key]);
                        console.log('count_option_price _price_rc[rc_key]', ledger_price_rc[rc_key]);
                                        }
                                    })
                                    // total += (typeof consecutive_node === 'object' && consecutive_node.price)? parseInt(consecutive_node.price): 0;
                                    total += (ledger_price_non * parseInt(list.consecutive_cnt));
                                }
                                cnt++;
                            });
                            return (total)? total: false;
                    }
                }
            }
        },
        // count_option_price: function(){
        //     return function (list){
        //         const node_id = list.facility_node_id;
        //         const finish_id = list.facility_node_finish;
        //         let ledger_price = 0;
        //         let ledger_price_non = 0;
        //         // 別オプション
        //         let ledger_price_rc = {};
        //         if(
        //             list.ledger_type && typeof list.ledger_type === 'object' 
        //         ){
        //             list.ledger_type.forEach(ledger => {
        //                 // ledger_price_non += (ledger.select_val_price)? parseInt(ledger.select_val_price): 0;
        //                 if(ledger.relation_column != ''){
        //                     if(!ledger_price_rc[ledger.relation_column]) ledger_price_rc[ledger.relation_column] = 0;
        //                     ledger_price_rc[ledger.relation_column] += parseInt(ledger.select_val_price);
        //                 }
        //                 else{
        //                     ledger_price_non += (ledger.select_val_price)? parseInt(ledger.select_val_price): 0;
        //                 }
        //             });
        //             console.log('total_price', ledger_price_non);
        //         }
        //         if(
        //             list.consecutive_cnt > 1
        //         ){
        //             let consecutive_cnt = 0;
        //             if(
        //                 typeof list === 'object' 
        //                 && typeof list.nodes === 'object' 
        //                 && Object.keys(list.nodes).length > 0 
        //                 && typeof ledger_price_rc === 'object' 
        //                 && Object.keys(ledger_price_rc).length > 0
        //             ){
        //                 Object.values(list.nodes).forEach(node => {
        //                     if(
        //                         consecutive_cnt > 0 
        //                         && list.consecutive_cnt >= consecutive_cnt
        //                     ){
        //             console.log('count_option_price consecutive_cnt ccc', ledger_price_rc);
        //                         Object.keys(ledger_price_rc).forEach(rc_key => {
        //                             // アルコール何時以降チェック
        //                             const set_time = parseInt(rc_key.replace('alcohol_', '') + '00');      
        //             console.log('count_option_price consecutive_cnt rc_key, set_time', rc_key, set_time, parseInt(ledger_price_rc[rc_key]), node);   
        //                             if(
        //                                 parseInt(ledger_price_rc[rc_key]) > 0 
        //                                 && typeof node === 'object' 
        //                                 && typeof node.items === 'object' 
        //                                 && Object.keys(node.items).length > 0 
        //                                 && typeof node.items[0] === 'object' 
        //                                 && typeof node.items[0].start_date_time === 'string' 
        //                                 && parseInt(node.items[0].start_date_time.replace(':', '')) >= set_time
        //                             ){
        //                                 ledger_price += parseInt(ledger_price_rc[rc_key]);
        //             console.log('count_option_price _price_rc[rc_key]', ledger_price_rc[rc_key]);
        //                             }
        //                         })

        //                     }
        //                     consecutive_cnt = consecutive_cnt + 1;
        //                 })
        //             }
        //             else{
        //                 ledger_price = (ledger_price_non * parseInt(list.consecutive_cnt));
        //             }
        //         }
        //         else{
        //             ledger_price = ledger_price_non;
        //         }
        //         console.log('count_option_price ledger_price_rc', ledger_price_rc);
        //         return ledger_price;
        //     }
        // },
        count_price_label: function(){
            const count_price_pf = this.count_price;
            return function (list){
                const p = count_price_pf(list);
                console.log('count_price_label', p, list);
                if(!p || p == false){
                    return '';
                }
                else{
                    return '¥' + this.number_format(p);
                }
            }
        },
        count_price: function(){
            const facility_nodes = this.facility_node;
            return function (list){
                const node_id = list.facility_node_id;
                const finish_id = list.facility_node_finish;

                if(typeof list === 'object' && list.nodes && typeof list.nodes === 'object'){
                    const target_node = list.nodes.find(node => {
                        return (node.id == node_id)
                    });
                    // const unit_time = (list.unit_time)? parseInt(list.unit_time): 30;
                    if(
                        typeof target_node === 'object' && target_node.consecutive_ids && 
                        typeof target_node.consecutive_ids === 'object' && target_node.consecutive_ids.length > 0
                        ){
                            let cnt = 0;
                            let total = (target_node.price)? parseInt(target_node.price): 0;
                            const index = target_node.consecutive_ids.indexOf(finish_id);
                            console.log('count_price index', index, finish_id);
                            target_node.consecutive_ids.forEach(consecutive_id => {
                                if(cnt <= index){
                                    const consecutive_node = facility_nodes.find((facility_node) => {
                                        return parseInt(facility_node.id) == parseInt(consecutive_id)
                                    });
                                    console.log('count_price consecutive_node', consecutive_node);
                                    total += (typeof consecutive_node === 'object' && consecutive_node.price)? parseInt(consecutive_node.price): 0;
                                }
                                cnt++;
                            });
                            console.log('count_price total', total, cnt);

                            return (total)? total: false;
                    }
                }
                
            }
        },
        target_category: function(){
            // const sel_group_id = this.sel_group_id;
            return this.facility_node_category.filter(
                cate => (
                    cate.group_id == this.facility_group_id 
                    && (
                        (this.facility_group_id != 9 && cate.front_status == 1) 
                        || (this.facility_group_id == 9)
                    )
                ));
        },
        target_node: function(){
            const nodes = this.facility_node;
            return function(category_id){
                return nodes.filter(node => {
                    return (node.category_id == category_id);
                });
            }
        },
        get_minimum_unit_prm: function(){
            return function(list){
                if(
                    typeof list === 'object' 
                    && typeof list.ledger_type === 'object' 
                ){
                    if(
                        typeof list.ledger_type.find(lt => lt.relation_column == 'facility_meal') === 'object' 
                        && parseInt(list.ledger_type.find(lt => lt.relation_column == 'facility_meal').select_val) == 22
                    ){
                        return parseInt(list.minimum_unit) * 2
                    }
                    else if(
                        typeof list.ledger_type.find(lt => lt.relation_column == 'gym_course') === 'object' 
                        && parseInt(list.ledger_type.find(lt => lt.relation_column == 'gym_course').select_val) == 34
                    ){
                        return parseInt(list.minimum_unit) + 1;
                    }
                    else{
                        return parseInt(list.minimum_unit);
                    }
                }
                return 1;
            }
        },
        list_nodes_finish_options: function(){
            const get_minimum_unit_prm = this.get_minimum_unit_prm;
            const facility_nodes = this.facility_node;
            // const list_options = this.list_nodes_options;
            return function(list){
                const tmps = [];
                const node_id = list.facility_node_id;
                console.log('list_nodes_finish_options list', node_id,  list);
                if(typeof list === 'object' && list.nodes && typeof list.nodes === 'object'){
                    // const target_node = list.nodes.find(node => node.id == node_id);
                    const target_node = list.nodes.find(node => {
                        return (node.id == node_id)
                    });
                    const unit_time = (list.unit_time)? parseInt(list.unit_time): 30;
                    // const minimum_unit = (list.minimum_unit)? parseInt(list.minimum_unit): false;
                    const minimum_unit = get_minimum_unit_prm(list);
                    if(
                        typeof target_node === 'object' && target_node.consecutive_ids && 
                        typeof target_node.consecutive_ids === 'object' && target_node.consecutive_ids.length > 0
                        ){

                        const target_node_item = (typeof target_node === 'object')? target_node.items[0]: false;
                        let cnt = 1;
                        const current = {
                            key: node_id,
                            // label: '〜' + target_node_item.end_date_time + '(' + (cnt * unit_time) + 'min)'
                            // label: '〜' + target_node_item.end_date_time + '(' + cnt + this.word_chg('セッション') + ')'
                            label: '〜' + target_node_item.end_date_time
                        }
                        if(
                            minimum_unit == false || (minimum_unit != false && minimum_unit <= cnt)
                        ){
                            tmps.push(current);
                        }

                        target_node.consecutive_ids.forEach(consecutive_id => {
                            cnt++;
                            const minimum_unit_wrap = (minimum_unit != false && (cnt % minimum_unit) == 0)? cnt / minimum_unit: false;
                            const consecutive_node = facility_nodes.find((facility_node) => {
                                return parseInt(facility_node.id) == parseInt(consecutive_id)
                            });
                            const consecutive_node_item = (typeof consecutive_node === 'object')? consecutive_node.items[0]: false;
                            if(
                                (consecutive_node_item) 
                                && (
                                    (
                                        minimum_unit == false 
                                        // || (minimum_unit != false && minimum_unit <= cnt)
                                        || (minimum_unit != false && minimum_unit_wrap !== false)
                                    )
                                )                            
                                ){
                                    // const lbl = (minimum_unit_wrap)? '(' + minimum_unit_wrap + this.word_chg('セッション') + ')': '';
                                    const lbl = '(' + (cnt * unit_time) + 'min)';
                                tmps.push(
                                    {
                                        key: consecutive_id,
                                        // label: '〜' + consecutive_node_item.end_date_time + '(' + (cnt * unit_time) + 'min)'
                                        label: '〜' + consecutive_node_item.end_date_time + lbl
                                    }
                                )
                            }
                        });
                        const consecutive_ids = parseInt(target_node.consecutive_ids);
                        console.log('list_nodes_finish_options consecutive_cnt', consecutive_ids, cnt);
                        // for(let i = 0;i<consecutive_cnt;i++){
                        // }
                    }
                }
                return tmps;
            }
        },
        list_nodes_options: function(){
            const targetSp = this.target_node;
            const targetDate = this.sprm.date;
            const facility_category = this.facility_node_category;
            // return this.facility_node_category.filter(category => {
            //     return (category.group_id == this.facility_group_id)
            // });
            // const consecutive_cnt = (this.sprm.consecutive_cnt)? parseInt(this.sprm.consecutive_cnt): false;
            return function(category_id){
                const nodes = targetSp(category_id).filter(tg => {return tg.range_start_date == targetDate});
                const category = facility_category.find(cate => {
                    return cate.id == category_id;
                });
                // console.log('list_nodes_options category', category);
                const consecutive_cnt = (typeof category === 'object' && category.minimum_unit && parseInt(category.minimum_unit) > 0)? parseInt(category.minimum_unit): false;
                // console.log('list_nodes_options consecutive_cnt', consecutive_cnt);
                // console.log('list_nodes_options', nodes, category_id);
                const tmp = [];
                if(typeof nodes === 'object' && nodes.length > 0){
                    nodes.forEach(node => {
                        if(
                            (
                                consecutive_cnt != false && consecutive_cnt > 0 
                                && consecutive_cnt <= parseInt(node.consecutive_cnt)
                            ) || consecutive_cnt == false
                        
                        ){
                            tmp.push({
                                key: node.id,
                                label: node.items[0].start_date_time + '〜',
                                // label: node.items[0].start_date_time + '〜(' + node.price + ')',
                                start_date_time: node.items[0].start_date_time,
                                end_date_time: node.items[0].end_date_time,
                            })
                        }
                    })
                }
                return tmp;
            }
        },
        facility_node_lists: function(){
            const tmps = [];
            const ledger_tmp = [...this.ledger_type]; 
            const ledgers = []
            if(ledger_tmp.length > 0){
                ledger_tmp.forEach(ledger => {
                    const lv = {...ledger};
                        console.log('facility_node_lists price chk', lv);
                    if(
                        lv.default_param && typeof lv.default_param === 'object' 
                        && lv.default_param.length > 0
                    ){
                        const default_param = [];
                        lv.default_param.forEach(param => {
                            const tmp_param = {...param};
                            // if(parseInt(tmp_param.price)){
                            //     const label = tmp_param['label'] + ' + ¥' + tmp_param['price'];
                            //     tmp_param['label'] = label;
                            // }
                            default_param.push({...tmp_param});
                        });
                        lv.default_param = default_param;
                        console.log('facility_node_lists price > 0', lv);
                    }
                    lv['select_val'] = '';
                    lv['select_val_price'] = 0;
                    ledgers.push(lv);
                })
            }
            if(Object.keys(this.node_category_facility).length > 0){
                this.node_category_facility.forEach(cate => {
                    const filters = [...ledgers].filter((type) => {
                        if(
                            typeof type === 'object' && typeof type.category_relation === 'object'
                            && type.category_relation.indexOf(cate.id) >= 0
                        ){
                            return type;
                        }
                    }).sort((a, b) => {
                        if(parseInt(a.sort) < parseInt(b.sort)){
                            return -1;
                        }else{
                            return 1;
                        }
                    });

                    const tmp = {
                        facility_node_id: 0,
                        facility_node_finish: '',
                        category_id: cate.id,
                        label: cate.label,
                        catgory_label: cate.label,
                        node_label: cate.label,
                        default_price: cate.default_price,
                        unit_time: cate.unit_time,
                        minimum_unit: cate.minimum_unit,
                        consecutive_cnt: cate.minimum_unit,
                        prices: [],
                        price_label: '',
                        nodes: this.target_node(cate.id),
                        ledger_type: filters,
                    }
                    if(
                        typeof this.target_node(cate.id) === 'object' 
                        && Object.keys(this.target_node(cate.id)).length > 0
                    ){
                        this.target_node(cate.id).forEach(node => {
                            if(!tmp.prices.includes(parseInt(node.price))){
                                tmp.prices.push(parseInt(node.price));
                            }
                        });
                        if(tmp.prices.length > 1){
                            tmp.prices.sort(function (a, b) {
                                return a - b;
                            });
                            tmp.price_label += tmp.prices[0];
                            tmp.price_label += ' - ';
                            tmp.price_label += tmp.prices[(tmp.prices.length - 1)];
                        }else{
                            tmp.price_label += tmp.prices[0];
                        }
                    }
                    if(
                        this.sprm.category_id > 0
                    ){
                        if(this.sprm.category_id == cate.id){
                            tmps.push({...tmp});
                        }
                    }else{
                        tmps.push({...tmp});
                    }
                })
            }
            return tmps;
        },
        node_category_group_facility:function(){
            return this.node_category_group.filter(grp => {
                return (grp.type == 'facility')
            });
        },
        node_category_facility:function(){
            return this.facility_node_category.filter(category => {
                return (category.group_id == this.facility_group_id)
            });
        },
        facility_group_id: {
            get: function (){
                if(this.search_disp_sw){
                    return this.facility_group_id_st;
                }else{
                    return this.facility_group_id_obj;
                }
            },
            set: function(value){
                if(this.search_disp_sw){
                    this.facility_group_id_st = value;
                }else{
                    this.$emit('to_push_select_date', value);
                }
            }
        },
        // facility_node_id: {
        //     get: function (){
        //         return this.facility_node_id_st;
        //     },
        //     set: function(value){
        //         this.facility_node_id_st = value;
        //     }
        // },
        // facility_node_finish: {
        //     get: function (){
        //         return this.facility_node_finish_st;
        //     },
        //     set: function(value){
        //         this.facility_node_finish_st = value;
        //     }
        // },
    },
    // watch:{
    //     facility_node_id(newVal, oldVal){
    //         console.log('watch facility_node_id', newVal, oldVal);
    //     }
    // },
    created () {
        if(this.$route.query.param_category_group_id){
            this.facility_group_id_st = this.$route.query.param_category_group_id;
        }
        if(this.$route.query.param_reserve_num) this.sprm.reserve_num = this.$route.query.param_reserve_num;
        if(this.$route.query.param_date){
            this.sprm.date = this.$route.query.param_date;
        }
        if(this.$route.query.param_category_id) this.sprm.category_id = this.$route.query.param_category_id;
        if(this.sprm.date){
            this.sprm.day = moment(this.sprm.date).format("D");
        }
        this.loadFacilityCategory();
        this.loadCategoryGroup();
        this.loadFacilityNode();
        this.loadUser();
        this.loadLedgerType();
      // this.sel_month = this.month_list[12].key;
    },
}
</script>
